export default __webpack_public_path__ + "images/brooklyn-made.5f9a0656836a5b118bda69f81c7f9b83.png";